import React, { useRef, useState } from 'react';
import { ReactComponent as Plus } from 'assets/icons/button/plus.svg';
import { Link } from 'react-router-dom';
import { ReactComponent as Arrow } from 'assets/icons/button/arrow.svg';
import ROUTES from 'constants/routes';

const FAQItem = ({ item }) => {


    const { name, countries } = item.attributes;
    const [active, setActive] = useState(false);
    const content = useRef(null);
    const [height, setHeight] = useState('0px');

    function toggleAccordion() {
        setActive(!active);
        setHeight(active ? '0px' : `${content.current.scrollHeight}px`);
    }

    return (
        <div className={`faq-item ${active ? '--open' : ''}`} onClick={toggleAccordion}>
            <div className={`faq-item__header `}>
                <div className="description2">{name}</div>
                <div className="faq-item__header-cross">
                    <Plus />
                </div>
            </div>

            <div ref={content} style={{ maxHeight: `${height}` }} className="faq-item__country-body">
                <div className="faq-item__country-container">
                    {countries.data?.map((item, index) => (
                        <Link key={index} to={`${ROUTES.location}/${item.attributes.slug}`} className="link">
                            {item.attributes.name}
                            <Arrow className="arrow" />
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQItem;
